export default "__VITE_ASSET__0e553300__"